export default {
    index: {
        title: 'Portfolio',
        description: 'Each collection is a group visitors switch between. The photographs (and their order) come from the media folder you point it at, so add and arrange pictures under {media}.',
        mediaLink: 'Media',
        noFolder: '(No folder)',
        newCollection: 'New collection',
        newCollectionPlaceholder: 'Capture',
        mediaFolder: 'Media folder',
        empty: 'No collections yet. Add one above and point it at a media folder.',
        noFolderHidden: 'No folder: not shown on the site',
        emptyFolderHidden: 'Folder is empty: not shown on the site',
        photos: 'no photos | {n} photo | {n} photos',
        confirmDelete: 'Delete “{name}”? The folder and its photographs are not touched.',
    },
};
